/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WorkflowsResponseDto } from '../../models/workflows-response-dto';

export interface ClientManagementGetActiveWorkflowsFromHyperScienceGet$Params {
}

export function clientManagementGetActiveWorkflowsFromHyperScienceGet(http: HttpClient, rootUrl: string, params?: ClientManagementGetActiveWorkflowsFromHyperScienceGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<WorkflowsResponseDto>>> {
  const rb = new RequestBuilder(rootUrl, clientManagementGetActiveWorkflowsFromHyperScienceGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<WorkflowsResponseDto>>;
    })
  );
}

clientManagementGetActiveWorkflowsFromHyperScienceGet.PATH = '/ClientManagement/GetActiveWorkflowsFromHyperScience';
